/**
 * @module components\ghTable\dataTable\dataRow\dataCell\iconCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";

@Component
export default class IconCell extends DataCellBase {}
